<div class="container">
  <form [formGroup]="newDocumentForm" (ngSubmit)="submitNewDocumentForm()">
    <mat-toolbar>
      <button mat-button type="submit" (click)="isPreview=true"
        [disabled]="!newDocumentForm.valid || fetchingSubmitForm">
        <div class="btn-login-content">
          @if (fetchingSubmitForm && isPreview) {
          <mat-spinner diameter="20" color="warn"></mat-spinner>
          }@else{
          <p>Vista previa</p>
          }
        </div>
      </button>
      &nbsp;
      <button class="update-button" type="submit" [disabled]="!newDocumentForm.valid || fetchingSubmitForm"
        mat-flat-button>
        <div class="btn-login-content">
          @if (fetchingSubmitForm && !isPreview) {
          <mat-spinner diameter="20" color="warn"></mat-spinner>
          }@else{
          <p>Aceptar</p>
          }
        </div>
      </button>
      &nbsp;
      <a mat-button (click)="location.back()">Cancelar</a>
      <span class="sgd-spacer"></span>
      @if(!usuarioAnterior){
      <button mat-stroked-button type="button" aria-label="Establecer #" [matMenuTriggerFor]="menu"
        matTooltip="Alcance y tr&aacute;mite padre">
        <mat-icon>keyboard_arrow_down</mat-icon>Adicional
      </button>
      <mat-menu #menu="matMenu">
        @if(!isEdit){
        <button mat-menu-item (click)="showNumeracion()"># Alcance</button>
        }
        <button mat-menu-item (click)="showTramitePadre()">Tr&aacute;mite padre</button>
      </mat-menu>
      }
    </mat-toolbar>
    <span [style.display]="isNumeracionManual && !isTramitePadre?'block':'none'">
      <div class="row">
        @if(!isEdit){
        <div class="col-12">
          <fieldset class="mat-mdc-card sgd-card">
            <legend># Alcance</legend>
            <p color="warn">Establece una numeraci&oacute;n arbitraria. Crea un documento si la numeraci&oacute;n no
              existe o da alcance con existente.</p>
            <div class="row">
              <div class="col-6">
                <mat-form-field class="full-width">
                  <mat-label>A&ntilde;o</mat-label>
                  <input matInput type="number" formControlName="anio" maxlength="4" min="2000" />
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="full-width">
                  <mat-label>N&uacute;mero dfw</mat-label>
                  <input matInput type="number" formControlName="numero" min="0" />
                </mat-form-field>
              </div>
            </div>
          </fieldset>
        </div>
        }
      </div>
    </span>
    <div class="row" [style.display]="isTramitePadre && !isNumeracionManual?'block':'none'">
      <div class="col-12">
        <fieldset class="mat-mdc-card sgd-card">
          <legend>Tr&aacute;mite padre</legend>
          <p color="warn">Crea un documento con nueva numeraci&oacute;n unido a un documento existente.
            <strong>Diferente numeraci&oacute;n.</strong>
          </p>
          <div class="row">
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>A&ntilde;o</mat-label>
                <input matInput type="number" (keydown.enter)="$event.preventDefault()" formControlName="anioPadre"
                  #anio minlength="4" maxlength="4" [value]="anioActual" />
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>N&uacute;mero</mat-label>
                <input matInput type="number" (keydown.enter)="$event.preventDefault()" formControlName="numeroPadre"
                  #numero minlength="1" />
                <span matSuffix>
                  <button mat-icon-button type="button" matTooltip="Buscar documento"
                    (click)="buscarDocumentoPadre(anio.value, numero.value)">
                    <mat-icon>search</mat-icon>
                  </button>
                </span>
              </mat-form-field>
            </div>
            <div class="col-sm-12">
              <mat-form-field class="full-width">
                <mat-label>Asunto</mat-label>
                <input type="text" (keydown.enter)="$event.preventDefault()" placeholder="Seleccione un documento"
                  aria-label="Number" matInput #tramitePadreInput formControlName="tramitePadre"
                  [matAutocomplete]="auto">
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
                  @for (option of optTramites; track option) {
                  <mat-option [value]="option">{{option.descripcion}} ({{option.oficio}})</mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <mat-tab-group  mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab  label="Informaci&oacute;n del documento" >
        <div>
        <ng-template mat-tab-label>
          <mat-icon class="material-symbols-outlined tab-icon">info</mat-icon>
          Informaci&oacute;n del documento
        </ng-template>
        <fieldset class="mat-mdc-card sgd-card " style="padding-top: 0; margin: 15px;">
          <legend>&nbsp;</legend>
          <button color="accent" mat-flat-button type="button" (click)="openDlgDestino()"
            style="position: absolute; top: -28px;">
            <mat-icon>person_search</mat-icon> Buscar participantes
          </button>&nbsp;
          <mat-card class="sgd-card" style="border: 0; margin-top: 0px; margin: 0px;">
            <div class="participantes-container">

              <mat-card-subtitle>
                De: &nbsp;
                @if (newDocumentForm.controls.participantes.hasError('requiredOrigen')) {
                <mat-error class="participante-label">Elegir al menos un remitente!</mat-error>
                }
                @for (participante of participantes.origen; track $index) {
                <div class="participante-label">
                  <!--<img src="assets/vacio.png" class="foto-para">-->
                  <mat-icon>account_circle</mat-icon>
                  <span>
                    {{participante.nombres | capitalize}}
                  </span>
                </div>
                }
              </mat-card-subtitle>
              <mat-card-subtitle>
                Para:
                @if (newDocumentForm.controls.participantes.hasError('requiredDestino')) {
                <mat-error class="participante-label">Elegir al menos un destinatario!</mat-error>
                }
                @for (participante of participantes.destinoBuzon; track $index) {
                <div class="participante-label">
                  <mat-icon>person</mat-icon>
                  <span>
                    {{participante.cargo}}
                  </span>
                </div>
                }
                @for (participante of participantes.destino; track $index) {
                <div class="participante-label">
                  <!--<img src="assets/vacio.png" class="foto-para">-->
                  <mat-icon>person</mat-icon>
                  <span>
                    {{participante.nombres | capitalize}}
                  </span>
                </div>
                }
              </mat-card-subtitle>
              <mat-card-subtitle>
                @if (participantes.copia.length){
                Copia:
                @for (participante of participantes.copia; track $index) {
                <!--<img src="assets/vacio.png" class="foto-para">-->
                <div class="participante-label">
                  <mat-icon>contact_page</mat-icon>
                  <span>
                    {{participante.nombres | capitalize}}
                  </span>
                </div>
                }
                }
              </mat-card-subtitle>
            </div>
          </mat-card>
        </fieldset>

        <div class="row" style="margin: 0;">
          <div class="col-6 col-lg-4">
            <mat-form-field class="full-width">
              <mat-label>Elegir una fecha</mat-label>
              <input matInput [matDatepicker]="picker" [max]="maxDate" formControlName="documentDate"
                (dateChange)="manageChangedDocumentDate($event)" (dateInput)="manageChangedDocumentDate($event)">
              <mat-hint>DD/MM/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-6 col-lg-4">
            <mat-form-field class="full-width">
              <mat-label>Tipo documento</mat-label>
              <mat-select (selectionChange)="manageChangedDocumentType($event)" [(value)]="defaultDocumentType"
                formControlName="documentType">
                @for (documentType of documentTypes; track $index) {
                <mat-option value={{documentType.id}}>{{documentType.descripcion}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-6 col-lg-4">
            <mat-form-field class="full-width">
              <mat-label>Categor&iacute;a</mat-label>
              <mat-select formControlName="category">
                <mat-option value="0">Extemporaneo</mat-option>
                <mat-option value="1">Normal</mat-option>
                <mat-option value="2">Personal</mat-option>
                <mat-option value="3">Urgente</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-6 col-lg-8">
            <mat-form-field class="full-width">
              <mat-label>N&uacute;mero de documento</mat-label>
              <input matInput formControlName="numeracion" #numeracionInput [readonly]="readOnlyNumeracion"
                maxlength="100" />
              @if(!isEdit){
              <button type="button" mat-icon-button matSuffix class="numeracion-field"
                matTooltip="Seleccionar numeraci&oacute;n" (click)="onDlgNumeracion()">
                <mat-icon>list</mat-icon>
              </button>
              }
            </mat-form-field>
          </div>

          <div class="col-6 col-lg-4">
            <mat-form-field class="full-width">
              <mat-label>N&uacute;mero referencia</mat-label>
              <input matInput formControlName="referenceNumber" />
            </mat-form-field>
          </div>
          <div class="col-12 col-lg-8 order-12 order-lg-10 d-flex align-items-center">
            <mat-form-field class="full-width small-form-field" style="flex: 1">
              <mat-label>Asunto</mat-label>
              <input matInput formControlName="asunto" type="" />
              @if (newDocumentForm.controls.asunto.getError('maxlength')) {
              <mat-error class="participante-label">Longitud máxima de 250 caracteres</mat-error>
              }
            </mat-form-field>
              @if (editor() == EditorType.odt) {
              <button mat-icon-button class="fullscreen-button" [class.active]="editorHasFocus || fullscreenActive" [color]="(editorHasFocus || fullscreenActive) ? 'primary' : ''" aria-label="Pantalla completa" type="button" [disabled]="!(editorHasFocus || fullscreenActive)" [matTooltip]="(editorHasFocus || fullscreenActive) ? 'Pantalla completa' : 'Seleccione el documento'" (click)="onFullscreen()">
                <mat-icon>fullscreen</mat-icon>
              </button>
              }
          </div>
          <div class="col-6 col-lg-4 order-10 order-lg-12">
            <mat-form-field class="full-width">
              <mat-label>Tipificaci&oacute;n</mat-label>
              <mat-select formControlName="tipificacion">
                <mat-option value="0">Sin tipificaci&oacute;n</mat-option>
                <mat-option value="1">Solicitud informaci&oacute;n p&uacute;blica</mat-option>
                <mat-option value="2">Confidencial</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        @if (editor() == EditorType.html) {
        <ngx-suneditor [options]="editorOptions" (onChange)="manageEditorContentChange($event)">ddd</ngx-suneditor>
        }

        @if (editor() == EditorType.odt) {
        @if (!collaboraUrl) {
        <div style="display: flex; align-items: center; justify-content: center; height: 60vh; flex-direction: column;">
          <mat-spinner diameter="50"></mat-spinner>
          <p style="margin-top: 1rem;">Inicializando editor...</p>
        </div>
        }@else{
        <app-collabora-editor #collaboraEditorComponent [editorUrl]="collaboraUrl" [fileName]="'documento.odt'"
          [fileExtension]="'odt'" [readOnly]="false" (editorReady)="onCollaboraReady()"
          (contentChanged)="onCollaboraContentChanged()" (error)="onCollaboraError($event)"
          (focusChange)="onEditorFocus($event)"
          style="display: block; width: 100%;  min-height: 500px;">
        </app-collabora-editor>
        }
        }
      </div>
      </mat-tab>
      <mat-tab label="Anexos">
        <ng-template mat-tab-label>
          <mat-icon class="material-symbols-outlined tab-icon">attach_file</mat-icon>
          Anexos
        </ng-template>
        @if(!documentID){
        <fieldset class="mat-mdc-card sgd-card" style="display: flex; margin: 0; margin-top: 15px;">
          <legend>Achivos anexos al documento</legend>
          <mat-card style="margin: 0;">
            <div class="anexos-add-button">
              <button type="button" mat-flat-button (click)="openDlgAnexos()">
                Agregar
                <mat-icon>add</mat-icon>
              </button>
            </div>
            <mat-list class="anexos-container">
              @for (anexo of anexos; track anexo) {
              @if (anexo.tipo !== 0) {
              <mat-list-item lines="3" style="height: auto;">
                <div class="anexos-acciones" matListItemIcon>
                  <button type="button" matTooltip="Descargar" mat-icon-button (click)="downloadAnexo(anexo.id!)">
                    <mat-icon>download</mat-icon>
                  </button>
                  @if(checkAnexoPDF(anexo.id!) && isEdit){
                  <button type="button" matTooltip="Firmar anexo" mat-icon-button (click)="openDlgSignAnexo(anexo.id!)">
                    <mat-icon>vpn_key</mat-icon>
                  </button>
                  }
                </div>
                <div matListItemTitle>
                  <a href="javascript:void(0)" matTooltip="{{anexo.nombre}}" (click)="openAnexo(anexo.id!)">{{
                    anexo.observacion? anexo.observacion:anexo.nombre }}</a>
                </div>
                <div matListItemLine>{{formatDate(anexo.fecha!)}}</div>
                @if(!this.documentID){
                <button type="button" mat-icon-button matListItemMeta (click)="onDeleteAnexo(anexo.id!)">
                  <mat-icon>delete</mat-icon>
                </button>
                }@else {
                <button type="button" mat-icon-button matListItemMeta (click)="onDeleteAnexoFijo(anexo.id!)">
                  <mat-icon>delete</mat-icon>
                </button>
                }
              </mat-list-item>
              }
              }
              @if(anexos.length <=0) { <p style="margin-left:16px">Aqu&iacute; se mostrar&aacute;n los archivos anexos
                al documento</p>}
            </mat-list>
          </mat-card>
        </fieldset>
        }@else if(anexos){
        <app-anexos-full [anexos]="anexos" [idTarea]="documentID" [isEdit]="true" [isAddAnexo]="true"
          [hasParticipated]="hasParticipated" [isOwner]="isOwner" [estadoTarea]="estadoTarea"></app-anexos-full>
        }
      </mat-tab>
    </mat-tab-group>
  </form>
</div>